import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';

import { candidateJobQueryKeys } from './queryKeys';

/**
 * The counts behind a job's candidate list (per origin, New Applicants),
 * independent of its status and search filters. Skipped while `jobId` is
 * undefined.
 */
export const useCandidateJobCountsQuery = (jobId: string | undefined) =>
  useQuery({
    queryKey: candidateJobQueryKeys.counts(jobId),
    queryFn: jobId
      ? async () => {
          const { data } = await fetchClient.GET(
            candidateEndpoints.candidateJobCounts,
            { params: { path: { jobId } } },
          );
          return data;
        }
      : skipToken,
  });
